import { render, staticRenderFns } from "./currentOrder.vue?vue&type=template&id=77fb095d&scoped=true&"
import script from "./currentOrder.vue?vue&type=script&lang=js&"
export * from "./currentOrder.vue?vue&type=script&lang=js&"
import style0 from "./currentOrder.vue?vue&type=style&index=0&id=77fb095d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb095d",
  null
  
)

export default component.exports